export const gamesGet = 'games:get';
export const gameStart = 'game:start';
export const casinoTickets = 'casino:tickets';
export const casinoRounds = 'casino:rounds';
export const gamesSearch = 'games:search';
